import React, {useEffect, useState} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {Student} from "../../shared/types/student";
import {loadStudentByIdFetch} from "../../app/axios/studentFetches";
import {useAppSelector} from "../../shared/hooks/useAppSelector";
import HLIconButton from "../../shared/components/icon-button/HLIconButton";
import ArrowBackIcon from "../../shared/styles/icons/ArrowBackIcon";
import classes from "./StudentPage.module.scss";
import StudentInfoCard from '../../components/student/info/StudentInfoCard';
import StudentLessonsCard from "../../components/student/lessons/StudentLessonsCard";
import FullPageLoader from "../../shared/components/full-page-loader/FullPageLoader";

const StudentPage = () => {
    const {id} = useParams();
    const {currentTeacher} = useAppSelector(state => state.auth);

    const [student, setStudent] = useState<Student | null>(null);
    const navigate = useNavigate();

    useEffect(() => {
        loadStudentByIdFetch(Number(id))
            .then(student => setStudent(student))
    }, [id]);

    if (!student) {
        return <FullPageLoader/>;
    }

    const onBack = () => navigate('/students')

    return (
        <div className="pageContainer">
            <div className="columnContainer">
                <HLIconButton
                    icon={<ArrowBackIcon/>}
                    onClick={onBack}
                    aria-label="Назад к ученикам"
                />
                <div className="inlineContainer">
                    <div className={classes.leftContainer}>
                        <StudentInfoCard student={student} setStudent={setStudent} currentTeacher={currentTeacher}/>
                    </div>
                    <div className={classes.rightContainer}>
                        <StudentLessonsCard/>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default StudentPage;